<!--
 * @Desc: 友情链接
   标签类名，使用-进行分割命名，如page-home、item-form
   标签id，使用小驼峰规则命名，如homeId、itemId
   变量名，使用小驼峰规则命名，如publicPath、wxCode
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-25 11:09:08
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-pay-type">
        <!-- 菜单 -->
        <!-- <menuCommon :active="active"></menuCommon> -->
        <!-- 内容区 -->
        <section class="pay-type">
            <div class="container">
                <div style="height:30px;"></div>
                <div class="pay-hold">
                    <div class="head">
                        <img src="../../public/statics/images/PayType/icon_1.png">
                        <div class="info">
                            <h1>您的订单已提交成功！请尽快付款</h1>
                            <p>支付金额：<span>￥{{ total_price }}</span>（住宿费每学期1000元）</p>
                        </div>
                    </div>
                    <h1 class="pay-title">请选择支付方式</h1>
                    <div class="pay-list">
                        <div class="pay-item" @click="payType = 1">
                            <el-radio v-model="payType" :label="1"></el-radio>
                            <img style="height:40px;" src="../../public/statics/images/PayType/alipay.png">
                            <img style="height:20px;margin-left: 20px;" src="../../public/statics/images/PayType/recommend.png">
                        </div>
                    </div>
                    <div class="subhold">
                        <el-button class="submit" size="default" type="primary" @click="toPay">立即支付</el-button>
                    </div>
                </div>
                <div style="height:30px;"></div>
            </div>
        </section>
        <div id="pay" style="display: none;"></div>
        <!-- 页脚 -->
        <!-- <footerCommon></footerCommon> -->
    </div>
</template>

<script>
import utils from "@/api/Utils.js"
import menuCommon from "./../components/Common/Menu.vue";
import footerCommon from "./../components/Common/Footer.vue";
import BreadCrumb from "./../components/Common/BreadCrumb.vue";
import RecommendedRead from "./../components/Common/RecommendedRead.vue";
import MenuVertical from "./../components/Common/MenuVertical.vue";
import LastRecommend from "./../components/Common/LastRecommend.vue";
export default {
    name: "home",
    data() {
        return {
            id:'',
            total_price:'',
            payType:''
        };
    },
    components: {
        menuCommon,
        footerCommon,
        BreadCrumb,
        RecommendedRead,
        MenuVertical,
        LastRecommend,
    },
    watch:{
        $route(val){
        }
    },
    created() {
        this.id = this.$route.query.id
        this.total_price = this.$route.query.total_price
    },
    mounted() {
        $("html,body").scrollTop(0);
    },
    beforeDestroy() {},
    methods: {
        // 吊起支付
        toPay(){
            if (!this.payType) {
                this.$message.error('请选择支付方式')
                return
            }
            let that = this
            that.$api.index.pcPay({apply_order_id:that.id}).then((res)=>{
                if(res.code == 200) {
                    const div = document.createElement('formdiv');
                    div.innerHTML = res.result.form_str;
                    document.body.appendChild(div);
                    document.forms['alipaysubmit'].setAttribute('target', '_self');
                    document.forms['alipaysubmit'].submit();
                    div.remove();
                }
            })
        },
        // 跳转到链接
        toPath(item){
            if(item.url) {
                window.open(item.url)
            }
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-pay-type {
    background: #FFF no-repeat top center;
}
/*  */
.page-pay-type .pay-type .container .pay-hold {
}
.page-pay-type .pay-hold .head{
    padding: 40px;
    display: flex;
    align-items: center;
    background: #f5f5f5;
}
.page-pay-type .pay-hold .head .info{
    margin-left: 30px;
}
.page-pay-type .pay-hold .head .info h1{
    font-size: 24px;
}
.page-pay-type .pay-hold .head .info p{
    font-size: 24px;
    margin-top: 10px;
}
.page-pay-type .pay-hold .head .info p span{
    font-size: 30px;
    color: #f65200;
}
.page-pay-type .pay-hold .pay-title{
    margin: 30px 0;
}
.page-pay-type .pay-hold .pay-list{}
.page-pay-type .pay-hold .pay-list .pay-item{
    width: 300px;
    height: 80px;
    border-radius: 6px;
    border: 1px solid #e5e5e5;
    padding: 16px;
    display: flex;
    align-items: center;
}
.page-pay-type .pay-hold .subhold{
    margin-top: 50px;
    text-align: center;
}
.page-pay-type .pay-hold .subhold .submit{
    background: #1677ff;
    border-color: #1677ff;
}
.page-pay-type .el-radio{margin-right: 10px;}
.page-pay-type /deep/ .el-radio__label{display: none;}
</style>